import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

import { StyledTypographyColorSectionNavLinkMain } from 'components/Cart/StyledTypographyColorSectionNavLinkMain';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { getButtonBackgroundHoverColor } from 'styles/helpers/getThemeStyles';

const StyledLocalOfferIcon = styled(LocalOfferIcon)(({ theme }) => ({
  marginTop: 10,
  marginBottom: 8,
  width: '16px',
  fill: getButtonBackgroundHoverColor(theme),
  '&.MuiSvgIcon-root': {
    marginRight: 8
  }
}));

const StyledTypography = styled(StyledTypographyColorSectionNavLinkMain)(() => {
  return {
    fontSize: 14,
    marginTop: 12
  };
});

function LocalOfferIconMessage({ message }) {
  return (
    <>
      <StyledLocalOfferIcon />
      <StyledTypography
        data-testid="promotion-text"
        variant={ITEM_DESCRIPTION_AND_PRICES}
      >
        {message}
      </StyledTypography>
    </>
  );
}

LocalOfferIconMessage.propTypes = {
  message: PropTypes.string
};

export default LocalOfferIconMessage;
